/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  pending: false,
  ptoDetails: {
    affiliateIsOriginator: true,
    affiliateIsRecipient: true,
    chainList: [],
    custody: '',
    dataCompany: '',
    errorMessage: '',
    inventorySelection: '',
    location: '',
    origin: '',
    originList: [],
    originator: '',
    product: '',
    ptoNumber: null,
    recipient: '',
    reconsignmentControl: '',
    referenceId: null,
    status: '',
    transferDate: '',
    volume: '',
  },
};

/**
 * Equivalent to the traditional reducer but:
 * - no switch statement
 * - no action constants
 * - able to apply updates in a mutable way
 */

const reducers = {
  fetchPtoDetailsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchPtoDetailsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchPtoDetailsSuccess(state, { payload }) {
    return R.assoc('ptoDetails', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'ptoDetails',
  reducers,
});

// Selectors
export const getPtoDetails = state => state.pto.ptoDetails.ptoDetails;
export const getPtoDetailsPending = state => state.pto.ptoDetails.pending;
export const getPtoDetailsError = state => state.pto.ptoDetails.error;

export const { fetchPtoDetailsPending, fetchPtoDetailsSuccess, fetchPtoDetailsError } = actions;

/**
 * Redux-thunk comes bundled and pre-configured
 * for creating asynchronous actions.
 */
let fetchController;
export const fetchPtoDetails = queryParams => dispatch => {
  const paramString = qs.stringify(queryParams, {
    allowDots: true,
    encode: false,
  });
  dispatch(fetchPtoDetailsPending(true));
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  http
    .get(`/product-transfer-orders/view-details?${paramString}`, { signal })
    .then(res => {
      dispatch(fetchPtoDetailsError(''));
      dispatch(fetchPtoDetailsSuccess(res.data));
      dispatch(fetchPtoDetailsPending(false));
    })
    .catch(error => {
      dispatch(
        createSnack({
          message: error.response.data.title,
          options: { variant: 'error' },
        })
      );
    });
};

export default reducer;
